<template lang="pug">
	.web-service-structure.flex-col.space-large
		.flex-row.justify.wrap
			.flex-col.nav-header
				.flex-row.space
					a(@click="() => $router.push({ path: `/wbs/List` })") {{$tCaption('External data services')}}
					template(v-if="service && service.Name")
						.spacer /
						span.nowrap {{service.Name}}
		.px-loader.loading.flex-row.space(v-if="isLoading")
			.loader
				i.fas.fa-circle-notch.fa-spin
			span {{$tCaption('Loading')}}..
		template(v-else)
			.flex-row.justify
				.flex-row
					.adt-tab.flex-row.space.align-center.center(v-for="tab in tabs", :class="{ active: tab.id === activeTab, 'disabled-controls': tab.disabled != null && (tab.disabled == true || tab.disabled()) }",
						@click="showTab(tab.id)")
						fas(v-if="tab.icon", :icon="tab.icon")
						span {{tab.text}}
				.flex-row.space.align-center.center
					DxButton(v-if="activeTab === 'serviceInfo'", :text="$tCaption('Test service response')", icon="fas fa-chevron-right", @click="showTab('response')", :focusStateEnabled="false", :activeStateEnabled="false")
					DxButton(v-if="activeTab === 'response'", :text="$tCaption('Outputs')", icon="fas fa-chevron-right", @click="showTab('outputs')", :disabled="!apiResponse", :focusStateEnabled="false", :activeStateEnabled="false")
			.flex-col.space-large.align-start(v-if="activatedTabs['serviceInfo']", v-show="activeTab === 'serviceInfo'")
				.flex-row.justify
					.flex-col
						.font-big.upper.grey {{$tCaption('Service info')}}
						.flex-row.space-small.life-status(:class="[ service.LifeStatus !== 0 ? 'error-colored' : 'grey' ]")
							span {{$tCaption('Status')}}:
							span {{service.TextStatus}}
					.flex-col.space
						DxButton(:text="$tCaption('Check life status')", :hint="$tCaption('Check life status with default parameters')", @click="checkLifeStatus", :icon="isCheckingLifeStatus ? 'fas fa-spinner fa-spin' : null" :disabled="isCheckingLifeStatus")
				.flex-row.space.full-width
					.flex-row.align-center.center
						ImageEditor(:objectId="service.Oid", :objectType="$Data.objectTypes.ExternalServiceDefinition", :url="service.ImageUrl", size="160px", fieldName="Image")
					.flex-col.space-large.align-start.flex-1
						.flex-row.space-large.full-width
							.flex-row.space.flex-1
								.flex-col.flex-3
									.font-small.upper.grey {{$tCaption('Name')}}
									DxTextBox(:value.sync="service.Name")
								.flex-col
									.font-small.upper.grey {{$tCaption('Category')}}
									Dropdown(:getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="$Data.getWebServiceCategories",
										:columns="[{ dataField: 'Name', caption: $tCaption('Category') }]",
										displayExpr="Name",
										valueExpr="Oid",
										:placeholder="$tCaption('Category')",
										:selectedItems="serviceCategoryOid",
										:showColumnHeaders="false",
										:filtersVisible="false",
										:searchVisible="true",
										:multiple="false",
										@select-data="v => service.ServiceCategory = v",
										:preloadedObjects="[service.ServiceCategory]")
							.flex-row.space.flex-1
								.flex-col.flex-1
									.font-small.upper.grey {{$tCaption('Method')}}
									DxSelectBox(:items="$methods", value-expr="id", display-expr="name", :search-enabled="false", :value.sync="service.JsonDefinition.Method")
								.flex-col.flex-2
									.font-small.upper.grey {{$tCaption('Base service')}}
									Dropdown(:getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results.filter(f => f.IsBaseService)", 
										:getData="(page,limit,opts) => $Data.getExternalServices(page, limit, {...(opts || {}), baseServices: true })",
										:columns="[{ dataField: 'Name', caption: $tCaption('Service') }]",
										displayExpr="Name",
										valueExpr="Oid",
										:placeholder="$tCaption('Base service')",
										:selectedItems="service.BaseServiceOid",
										:showColumnHeaders="false",
										:filtersVisible="false",
										:searchVisible="true",
										:multiple="false",
										@select-data="v => service.BaseServiceOid = v && v.Oid || null")
						.flex-col.flex-1.full-width
							.font-small.upper.grey {{$tCaption('URL')}}
							DxTextBox.flex-1(:value="service.JsonDefinition.Url", @value-changed="e => $set(service.JsonDefinition, 'Url', e.value)")
						.flex-row.space-large.align-start
							.flex-col
								.font-small.upper.grey &nbsp;
								DxCheckBox(:value.sync="dontUseCache", :text="$tCaption(`Don't use cache`)")
							.flex-col
								.font-small.upper.grey &nbsp;
								DxCheckBox(:value.sync="dontSaveRequests", :text="$tCaption(`Don't save requests`)")
							.flex-col
								.font-small.upper.grey &nbsp;
								DxCheckBox(:value.sync="service.IsBaseService", :text="$tCaption('Is base service')")
							.flex-col
								.font-small.upper.grey &nbsp;
								DxCheckBox(:value.sync="service.CheckLifeStatus", :text="$tCaption('Check life status')")
							.flex-col(v-if="service.JsonDefinition.Method === 0")
								.font-small.upper.grey &nbsp;
								DxCheckBox(:value.sync="useCustomPostData", :text="$tCaption('Custom post data')")
						.flex-row.space-large.full-width
							.flex-col.flex-2
								.font-small.upper.grey {{$tCaption('Description')}}
								DxTextBox(:value.sync="service.Description")
							.flex-col.flex-2
								.font-small.upper.grey {{$tCaption('Documentation URL')}}
								DxTextBox(:value.sync="service.DocumentationUrl")
							.flex-col.flex-1
								.font-small.upper.grey {{$tCaption('Cache lifetime (minutes)')}}
								DxNumberBox(:value="service.JsonDefinition.CacheLifetime || 60", @value-changed="e => $set(service.JsonDefinition, 'CacheLifetime', e.value)")
							.flex-col.flex-1
								.font-small.upper.grey {{$tCaption('Code')}}
								.flex-row.space.align-center
									DxButton(v-if="!isEditingCode", icon="edit", @click="editCode", stylingMode="text")
									DxTextBox(:value.sync="service.Code", :hint="service.Code", :disabled="!isEditingCode")
						.flex-row.space-large.full-width
							.font-small.upper.grey {{$tCaption('Script engine')}}
								.flex-row.space.align-center
								DxSelectBox(:data-source="engineTypes", :value="service.JsonDefinition.ScriptEngine || 0", valueExpr="id", displayExpr="text", 
									:placeholder="$tCaption('Engine')", @value-changed="e => $set(service.JsonDefinition, 'ScriptEngine', e.value)", :width="80")
							.flex-col
								.font-small.upper.grey {{$tCaption('Number of retries')}}
								DxNumberBox(:value="service.JsonDefinition.NumberOfRetries || 0", @value-changed="e => $set(service.JsonDefinition, 'NumberOfRetries', e.value)", :width="120")
				.flex-col.full-width(v-if="service.JsonDefinition.Method === 0 && useCustomPostData")
					.font-small.upper.grey {{$tCaption('Custom post data')}}
					DxTextArea(:value.sync="service.JsonDefinition.CustomPostData", :height="220", width="100%")
				.space
				.flex-row.space.align-center
					.font-big.upper.grey {{$tCaption('Parameters')}}
					DxButton(icon="plus", @click="addParameter")
				.flex-col.space.parameters.align-start
					.parameter.flex-row.space.wrap.padded-children(v-for="(param, pIdx) in service.JsonDefinition.Parameters")
						DxButton(icon="trash", stylingMode="text", type="danger" @click="() => { processParametersChangeInUrl(param.Name, '', true); service.JsonDefinition.Parameters.splice(pIdx, 1); }")
						.flex-col
							.font-small.upper.grey {{$tCaption('Parameter name')}}
							DxTextBox(v-if="!param.ComplexParameterId", :value="param.Name", @value-changed="e => { processParametersChangeInUrl(e.value, param.Name); param.Name = e.value; }")
							.grey.param-name(v-else) {{param.Name}}
						.flex-col(v-if="!param.ComplexParameterId")
							.font-small.upper.grey {{$tCaption('Caption')}}
							DxTextBox(:value="param.Caption", @value-changed="e => $set(param, 'Caption', e.value)")
						.flex-col
							.font-small.upper.grey {{$tCaption('Value')}}
							DxTextBox(:value.sync="param.Value")
						.flex-col
							.font-small.upper.grey {{$tCaption('Format')}}
							DxTextBox(:value.sync="param.Format", :width="90")
						.flex-col
							.font-small.upper.grey {{$tCaption('Param type')}}
							DxSelectBox(:items="$paramTypes", value-expr="id", display-expr="name", :search-enabled="false", :value.sync="param.ParamType", :width="130", 
								@value-changed="processParametersChangeInUrl(param.Name, param.Name, param.ParamType !== 0)")
						.flex-col
							.font-small.upper.grey {{$tCaption('Data type')}}
							DxSelectBox(:items="$parametersDataTypes", value-expr="id", display-expr="name", :search-enabled="false", :value.sync="param.DataType", :width="90", :disabled="!!param.ComplexParameterId")
						.flex-col.space
							.font-small.upper.grey {{$tCaption('Options')}}
							DxCheckBox.nowrap(:value.sync="param.UserEditable", :text="$tCaption('Editable for user')", :disabled="!!param.ComplexParameterId")
							DxCheckBox.nowrap(v-if="param.UserEditable", :value="param.IsRequired || false", :text="$tCaption('Required')", :disabled="!!param.ComplexParameterId", @value-changed="e => $set(param, 'IsRequired', e.value)")
							template(v-if="param.DataType === 'date'")
								DxCheckBox.nowrap(:value="param.UseTargetTimeZone || false", :text="$tCaption('Use target time zone')", @value-changed="e => $set(param, 'UseTargetTimeZone', e.value)")
								DxCheckBox.nowrap(:value="param.AllowTime || false", :text="$tCaption('Allow time selection')", @value-changed="e => $set(param, 'AllowTime', e.value)")
							template(v-if="param.DataType === 'list'")
								DxCheckBox.nowrap(:value="param.MultiSelect || false", :text="$tCaption('Multi-select')", @value-changed="e => $set(param, 'MultiSelect', e.value)")
						.flex-col(v-if="param.DataType === 'list'")
							.flex-row.space.align-center
								.font-small.upper.grey {{$tCaption('List options')}} ({{param.ListOptions.length}})
								a(@click="addListOption(param.ListOptions, `parameter_${pIdx}`)")
									i.fas.fa-plus
							DxScrollView.scroll-view(:ref="`parameter_${pIdx}`", showScrollbar="always", direction="vertical")
								.list-options.flex-col.space
									.flex-row.center.space(v-for="(lo, loIdx) in param.ListOptions")
										DxButton(icon="trash", stylingMode="text", type="danger" @click="param.ListOptions.splice(loIdx, 1)")
										DxTextBox(:value.sync="lo.Key", :placeholder="$tCaption('Key')")
										DxTextBox(:value.sync="lo.Value", :placeholder="lo.Key ? `${$tCaption('Value')}: ${lo.Key}` : $tCaption('Value')")
						template(v-if="!param.ComplexParameterId")
							.flex-col.space
								.flex-col
									.font-small.upper.grey {{$tCaption('Parent service')}}
									Dropdown(:getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", 
										:getData="getBaseServices",
										:columns="[{ dataField: 'Name', caption: $tCaption('Service') }]",
										displayExpr="Name",
										valueExpr="Oid",
										:placeholder="$tCaption('Base service')",
										:selectedItems="param.ParentServiceOid",
										:showColumnHeaders="false",
										:filtersVisible="false",
										:searchVisible="true",
										:multiple="false",
										:width="220",
										@select-data="v => $set(param, 'ParentServiceOid', v && v.Oid || null)")
								.flex-col(v-if="param.ParentServiceOid")
									Dropdown(:getTotal="(r) => r.Results[0].JsonDefinition.Outputs.length", :getItems="(r) => r.Results[0].JsonDefinition.Outputs",
										:watchReload="param.ParentServiceOid",
										:getData="(page,limit,opts) => $Data.getExternalServices(page, limit, { byKey: param.ParentServiceOid })",
										:columns="[{ dataField: 'Name', caption: $tCaption('Output') }]",
										displayExpr="Name",
										valueExpr="Name",
										:placeholder="$tCaption('Output')",
										:selectedItems="param.ParentServiceOutput",
										:showColumnHeaders="false",
										:filtersVisible="false",
										:searchVisible="true",
										:multiple="false",
										:width="220",
										@select-data="v => $set(param, 'ParentServiceOutput', v && v.Name || null)")
							.flex-col(v-if="service.JsonDefinition.Outputs.length")
								.font-small.upper.grey {{$tCaption('Target outputs')}}
								Dropdown(:getTotal="(r) => r.length", :getItems="(r) => r", :getData="getOutputsData",
									:watchReload="service.JsonDefinition.Outputs",
									:columns="[{ dataField: 'Name', caption: $tCaption('Name') }]",
									displayExpr="Name",
									valueExpr="Name",
									:placeholder="$tCaption('Output')",
									:selectedItems="param.TargetOutputs || []",
									:showColumnHeaders="false",
									:filtersVisible="false",
									:searchVisible="true",
									:multiple="true",
									@select-data="v => service.ServiceCategory = v",
									@change="(v) => $set(param, 'TargetOutputs', v)")
				template(v-if="service.JsonDefinition.ComplexParameters")
					.flex-row.space.align-center
						.font-big.upper.grey {{$tCaption('Complex parameters')}}
						DxButton(icon="plus", @click="addComplexParameter")
					.flex-col.space.parameters.align-start
						ComplexParameter.parameter(v-for="(param, pIdx) in service.JsonDefinition.ComplexParameters", :param="param", 
							@delete="service.JsonDefinition.ComplexParameters.splice(pIdx, 1); processComplexParameterOutput(param, true)",
							@change="processComplexParameterOutput(param)", :key="pIdx")
				.flex-row.space
					DxButton(:text="$tCaption('Delete service')", type="danger", icon="close", @click="removeService", :disabled="!!isSaving")
					DxButton(:text="$tCaption('Clone service')", icon="fas fa-copy", @click="cloneService", :disabled="!!isSaving")
			.flex-col.space.align-start(v-show="activeTab === 'response'", v-if="activatedTabs['response']",)
				Caller(ref="caller", :service="service", :startImmediate="true", @output="(r,p,o) => { apiResponse = r; apiParams = p; apiOriginalResponse = o; }")
			Outputs(v-show="activeTab === 'outputs'", v-if="activatedTabs['outputs']", :service="service", :outputDataTypes="$outputDataTypes", :outputEvalTypes="$outputEvalTypes", 
				:apiResponse="apiResponse", :apiParams="apiParams", :originalResponse="apiOriginalResponse")
</template>

<script>
	import _ from 'lodash';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxNumberBox from 'devextreme-vue/number-box';
	import { DxCheckBox } from 'devextreme-vue/check-box';
	import DxButton from 'devextreme-vue/button';
	import Caller from './Caller.vue';
	import DxScrollView from 'devextreme-vue/scroll-view';
	import DxTextArea from 'devextreme-vue/text-area';
	import Popup from 'app-core/Popup.vue';
	import Data from 'app-core/Data';
	import { EXTERNAL_SERVICES_CATEGORIES, SERVICE_STATUSES } from 'app-core/constants';
	import Dropdown from 'app-core/Dropdown.vue';
	import ImageEditor from 'app-core/ImageEditor.vue';
	import ComplexParameter from './ComplexParameter.vue';
	import Outputs from './Outputs.vue';

	export default {
		translationCategory: 'webServiceCaller.StructureBuilder',
		name: 'web-service-structure',
		components: {
			DxSelectBox, DxCheckBox, DxTextBox, DxButton, Caller, DxScrollView, DxTextArea, Popup, Dropdown, ImageEditor, ComplexParameter,  DxNumberBox, Outputs
		},
		props: ['id'],
		data() {
			this.$paramTypes = [{ id: 0, name: () => this.$tCaption('Query string') }, { id: 1, name: () => this.$tCaption('Header') }, { id: 2, name: () => this.$tCaption('Data') }];
			this.$parametersDataTypes = this.$Data.externalServicesParametersDataTypes().map(f => ({ id: f, name: f }));
			this.$outputDataTypes = this.$Data.externalServicesOutputsDataTypes().map(f => ({ id: f, name: f }));
			this.$methods = ['POST', 'GET'].map((f, i) => ({ id: i, name: f }));
			this.$outputEvalTypes = ['script', 'selector'].map((f, i) => ({ id: i, name: f }));
			const lifeStatuses = SERVICE_STATUSES.toLocale('name', this).map(f => f.name);
			return {
				service: {
					Oid: null,
					Name: '',
					Url: '',
					JsonDefinition: {
						ComplexParameters: [],
						Parameters: [],
						Outputs: [],
						CustomPostData: null,
						Method: 1,
						DontUseCache: false,
						DontSaveRequests: false,
						CacheLifetime: 60,
						ScriptEngine: 1,
						NumberOfRetries: 0
					},
					BaseServiceOid: null,
					IsBaseService: false,
					Description: null,
					DocumentationUrl: null,
					CheckLifeStatus: false
				},
				useCustomPostData: false,
				isLoading: false,
				categories: EXTERNAL_SERVICES_CATEGORIES.toLocale('name', this),
				isSaving: 0,
				tabs: [
					{ id: 'serviceInfo', text: this.$tCaption('Service info'), icon: 'circle-info' },
					{ id: 'response', text: this.$tCaption('API response'), icon: 'rectangle-list' },
					{ id: 'outputs', text: this.$tCaption('Outputs'), disabled: () => !this.apiResponse, icon: 'code' }
				],
				activeTab: 'serviceInfo',
				apiResponse: null,
				apiOriginalResponse: null,
				apiParams: null,
				activatedTabs: {},
				isEditingCode: false,
				isCheckingLifeStatus: false,
				lifeStatuses,
				engineTypes: [ 
					{ id: 0, text: this.$tCaption('Jint') },
					{ id: 1, text: this.$tCaption('Node') }
				]
			};
		},
		computed: {
			serviceCategoryOid() {
				return this.service?.ServiceCategory?.Oid;
			},
			dontUseCache: {
				get: function() { return !!this.service?.JsonDefinition.DontUseCache; },
				set: function(v) { this.$set(this.service.JsonDefinition, 'DontUseCache', v); }
			},
			dontSaveRequests: {
				get: function() { return !!this.service?.JsonDefinition.DontSaveRequests; },
				set: function(v) { this.$set(this.service.JsonDefinition, 'DontSaveRequests', v); }
			}
		},
		watch: {
			useCustomPostData(v) {
				if (v)
					this.prepareCustomPostData();
				else
					this.service.JsonDefinition.CustomPostData = null;
			},
			service: {
				handler() {
					this.save();
				},
				deep: true
			},
			id() {
				if (this.service.Oid !== this.id)
					this.loadService();
			},
			'service.JsonDefinition.Parameters': {
				handler() {
					this.prepareCustomPostData();
				},
				deep: true
			},
			'service.JsonDefinition.Url'() {
				this.prepareURLParameters();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.externalService = this;
			this.loadService();
			this.showTab('serviceInfo');
		},
		destroyed() {
			delete this.$paramTypes;
			delete this.$methods;
			delete this.$parametersDataTypes;
			delete this.$outputDataTypes;
			delete this.$outputEvalTypes;
		},
		methods: {
			checkLifeStatus() {
				this.isCheckingLifeStatus = true;
				this.$Data.postExternalApi('ExternalService/CheckLifeStatus', {
					Id: this.service.Oid,
					Type: this.$Data.objectTypes.ExternalServiceDefinition
				}).then(r => {
					this.service.LifeStatus = r?.Data?.LifeStatus;
					this.service.TextStatus = r?.Data?.TextStatus;
				}).finally(() => this.isCheckingLifeStatus = false);
			},
			editCode() {
				if (!this.service.Code) {
					this.isEditingCode = true;
					return;
				} 
				this.$confirmMessage({
					title: () => this.$tCaption('Warning', '@actions'),
					text: this.$tCaption('Note: if you change service code you should manually change it in places where it was used.'),					
					buttons: [
						{
							text: this.$tCaption('Continue', '@actions'),		
							onClick: () => this.isEditingCode = true,
							type: 'success'
						},
						{
							text: this.$tCaption('Cancel', '@actions'),
						}
					]
				});
			},
			showTab(tab) {
				this.$set(this.activatedTabs, tab, true);
				this.activeTab = tab;
			},
			getBaseServices(pageIndex, limit, opts) {
				return this.$Data.getExternalServices(0, 9999, { ...(opts || {}), baseServices: true }).then(r => {
					let services = r.Results.filter(f => f.IsBaseService);
					if (opts?.byKey) {
						services = services.filter(f => f.Oid === opts?.byKey);
					}
					return {
						TotalNumberOfRecords: services.length,
						Results: services.slice(pageIndex * limit, (pageIndex + 1) * limit)
					}
				})
			},
			processParametersChangeInUrl(newVal, oldVal, removed) {
				const url = this.service.JsonDefinition.Url || '';
				const leftPart = url.split('?')[0];
				let paramsPart = url.split('?')[1] || '';
				let hasParams = paramsPart.length > 1;

				if (!removed) {
					if ((oldVal || !newVal) && paramsPart.indexOf(`{${oldVal}}`) > -1) {
						paramsPart = paramsPart
							.replace(new RegExp(`{${oldVal}}`, 'g'), `{${newVal}}`)
							.replace(new RegExp(`${oldVal}=`, 'g'), `${newVal}=`);
					} else if (newVal) {
						if (!paramsPart) {
							paramsPart = `${newVal}={${newVal}}`;
						} else {
							if (paramsPart.indexOf(`{${newVal}}`) === -1)
								paramsPart += `&${newVal}={${newVal}}`;
						}
					}
				} else {
					let paramsParts = paramsPart.split('&');
					paramsPart = paramsParts.filter(f => f.indexOf(`{${newVal}}`) === -1).join('&');
				}

				this.service.JsonDefinition.Url = leftPart + '?' + paramsPart ;

				if (__DEBUG__)
					console.debug('processParametersChangeInUrl', { newVal, oldVal, removed, leftPart, hasParams, url, paramsPart, newUrl: this.service.JsonDefinition.Url });
			},
			addComplexParameter() {
				const param = {
					Id: this.$Data.uuid(),
					Name: this.$tCaption('CP') + (this.service.JsonDefinition.ComplexParameters.length + 1),
					Description: null,
					Type: 'geoplace',
					Keys: ['Lat', 'Lon']
				};
				this.service.JsonDefinition.ComplexParameters.push(param);
				this.processComplexParameterOutput(param);
			},
			processComplexParameterOutput(complexParam, remove) {
				const checkParam = (paramKey, data) => {
					let param = this.service.JsonDefinition.Parameters.find(f => f.ComplexParameterKey === paramKey && f.ComplexParameterId === complexParam.Id);
					const defParam = this.$Data.complexExternalServicesTypes[complexParam.Type].parameters.find(f => f.name === paramKey);
					if (!param) {
						param = {
							ParamType: defParam?.paramType || 0,
							DataType: defParam?.dataType || 'string',
							UserEditable: false,
							...(data || {}),
							Name: `${complexParam.Name}_${paramKey}`,
							ComplexParameterId: complexParam.Id,
							ComplexParameterKey: paramKey
						}
						this.service.JsonDefinition.Parameters.push(param);
						this.processParametersChangeInUrl(`${complexParam.Name}_${paramKey}`, '', param.ParamType !== 0);
					} else {
						this.processParametersChangeInUrl(`${complexParam.Name}_${paramKey}`, param.Name, param.ParamType !== 0);
						param.Name = `${complexParam.Name}_${paramKey}`;
					}
				}
				if (remove) {
					let index = this.service.JsonDefinition.Parameters.findIndex(f => f.ComplexParameterId === complexParam.Id);
					while(index >= 0) {
						const paramName = this.service.JsonDefinition.Parameters[index].Name;
						this.processParametersChangeInUrl(paramName, paramName, true);
						this.service.JsonDefinition.Parameters.splice(index, 1);
						index = this.service.JsonDefinition.Parameters.findIndex(f => f.ComplexParameterId === complexParam.Id);
					}
					return;
				}
				(complexParam.Keys || []).map(f => checkParam(f));
				const removeParams = this.service.JsonDefinition.Parameters.filter(f => !complexParam.Keys?.includes(f.ComplexParameterKey) && f.ComplexParameterId === complexParam.Id);
				removeParams.map(f => {
					this.processParametersChangeInUrl(f.Name, f.Name, true);
					this.service.JsonDefinition.Parameters.splice(this.service.JsonDefinition.Parameters.findIndex(p => p.Name === f.Name), 1);
				});
			},
			getOutputsData() {
				return Promise.resolve(this.service.JsonDefinition.Outputs);
			},
			prepareURLParameters() {
				if (this.service.JsonDefinition.Url && this.service.JsonDefinition.Parameters.length === 0) {
					const url = new URL(this.service.JsonDefinition.Url);
					const params = url.search ? `${decodeURIComponent(url.search)}`.substring(1).split('&') : [];
					if (params.length) {
						var linkParams = [];
						params.map(f => {
							const param = `${f}`.split('=');
							var name = !param[1] ? param[0] : (param[1] && param[1].substr(0,1) === '{' && param[1].substr(-1,1) === '}' ? param[1].replace('{','').replace('}','') : param[0]);
							linkParams.push(`${param[0]}={${name}}`);
							this.service.JsonDefinition.Parameters.push({
								Name: name,
								Value: param[1] !== `{${name}}` ? param[1] : null,
								UserEditable: false,
								ParamType: 0,
								DataType: 'string',
								ListOptions: []
							});
						});
						this.service.JsonDefinition.Url = `${decodeURIComponent(url.origin)}${decodeURIComponent(url.pathname)}?${linkParams.join('&')}`;
					}
				}
			},
			prepareCustomPostData(force) {
				if (this.useCustomPostData && !this.service.JsonDefinition.CustomPostData || force) {
					var data = {};

					this.service.JsonDefinition.Parameters.filter(f => f.ParamType === 2).map(f => {
						data[f.Name] = `@${f.Name}`;
					});

					if (Object.keys(data).length > 0)
						this.$set(this.service.JsonDefinition, 'CustomPostData', JSON.stringify(data, null, '\t'));
				}
			},
			loadService() {
				if (!this.id || this.id === 'new') {
					if (__DEBUG__)
						console.debug('New service');
					this.service = {
						Oid: null,
						Name: '',
						Url: '',
						JsonDefinition: {
							ComplexParameters: [],
							Parameters: [],
							Outputs: [],
							CustomPostData: null,
							Method: 1,
							DontUseCache: false,
							DontSaveRequests: false,
							CacheLifetime: 60,
							ScriptEngine: 1,
							NumberOfRetries: 0
						},
						BaseServiceOid: null,
						IsBaseService: false,
						Description: null,
						DocumentationUrl: null,
						CheckLifeStatus: false
					};
				} else {
					this.isLoading = true;
					this.$Data.getExternalService(this.id, true).then(r => {
						this.service = r;
						if (!this.service?.JsonDefinition?.ComplexParameters) {
							this.$set(this.service.JsonDefinition, 'ComplexParameters', []);
						}
						this.useCustomPostData = !!this.service.JsonDefinition.CustomPostData;
					}).finally(() => this.isLoading = false);
				}
			},
			save() {
				if (__DEBUG__)
					console.debug('Save service', { id: this.service.Oid });

				if (!this.service.Code) {
					this.service.Code = this.$Data.formatStringAsKey(this.service.Name);
				}
				if (!this.service.Code) return Promise.resolve(this.service);

				if (this.isLoading) return;
				if (!this.service.Oid) {
					this.isLoading = true;
				}
				this.isSaving++;
				if (this.isSaving > 1) return;				
				return Data.postExternalApi('ExternalService/CreateUpdateExternalService', this.service).then(async r => {
					if (__DEBUG__)
						console.debug('Service created/updated', r);
					if (!this.service.Oid) {
						this.service.Oid = r.Data.Oid;
						this.$router.push({
							path: `/wbs/Builder/${this.service.Oid}`
						});
						(await this.$Data.getExternalServices(0,0)).DataSource.push(this.service);
					} else {
						_.assign(await this.$Data.getExternalService(this.service.Oid), this.service);
					}
				}).finally(() => {
					if (this._isDestroyed) return;
					this.isLoading = false;
					if (this.isSaving > 1) {
						this.isSaving = 0;
						this.save();
					} else {
						this.isSaving = 0;
					}
				});
			},
			addParameter() {
				this.service.JsonDefinition.Parameters.push({
					Name: null,
					Value: null,
					UserEditable: false,
					ParamType: 0,
					DataType: 'string',
					ListOptions: []
				});
			},
			addListOption(holder, scrollViewRef) {
				holder.push({ Key: null, Value: null });
				setImmediate(() => {
					if (this._isDestroyed) return;
					var scrollView = this.$refs[scrollViewRef][0];
					if (scrollView && scrollView.instance) {
						scrollView.instance.scrollBy(10000);
					}
				});
			},
			removeService() {
				this.$confirmMessage({
					title: () => this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Are you sure you want to delete service?'),
					handler: () => {
						this.isLoading = true;
						Data.getExternalApi('ExternalService/DeleteExternalService',`oid=${this.service.Oid}`).then(async r => {
							if (__DEBUG__)
								console.debug('Service deletion result', { r });
							if (r.Success) {
								const externalServices = (await this.$Data.getExternalServices(0,0)).DataSource;
								const idx = externalServices.findIndex(f => f.Oid === this.service.Oid);
								if (idx > -1)
									externalServices.splice(idx, 1);
								this.$router.push({
									path: '/wbs/List'
								});
							}
						}).finally(() => {
							if (this._isDestroyed) return;
							this.isLoading = true;
						});
					}
				});
			},
			cloneService() {
				this.isLoading++;
				this.$Data.postExternalApi('Service/CloneObject', {
					Id: this.service.Oid,
					Type: this.$Data.objectTypes.ExternalServiceDefinition
				}).then(r => {
					if (typeof(r?.Data) === 'string') {
						this.$router.push({
							path: `/wbs/Builder/${r?.Data}`
						});
					}
				}).finally(() => this.isLoading--);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.web-service-structure {
		padding: 20px;

		.parameters, .outputs {
			margin-left: 20px;
		}

		.parameter, .output {
			margin-bottom: 4px;
			background: rgba(255,255,255,0.5);
			padding: 10px;
			border-radius: 4px;
		}

		.scroll-view {
			max-height: 120px;
		}

		.param-name {
			min-width: 180px;
		}

		.nowrap {
			.dx-checkbox-text {
				white-space: nowrap !important;
			}
		}
	}

	.web-service-param-button {
		padding: 9px 10px;
		background: rgba(0,0,0,0.035);
		border-radius: 4px;
		transition: 0.3s;
		cursor: pointer;

		&:hover {
			background: $base-accent;
			color: $base-bg;
		}

		.dx-texteditor.dx-editor-underlined::after {
			border-bottom: none !important;
		}
		
		.dx-texteditor.dx-editor-underlined .dx-placeholder::before, .dx-texteditor.dx-editor-underlined .dx-texteditor-input {
			padding: 0px !important;
		}

		&.associated {
			background: $base-accent !important;
			color: $base-bg !important;
			font-weight: 400;
		}
	}

	.web-service-param-output {
		&.associated {
			color: $base-accent;
			font-weight: 400;
		}
	}

	.actions-description {
		position: absolute;
		top: 9px;
		left: 10px;
		opacity: 0.3;
		pointer-events: none;
		user-select: none;
	}
</style>
